// exclude-from-index
import React from 'react';
import PropTypes from 'prop-types';
import {
  NumberToggleWrapper,
  NumberToggleUp,
  NumberToggleInput,
  NumberToggleInputClone,
  NumberToggleDown
} from './NumberToggle.styles';

function NumberToggle(props) {
  const { disabled, max, min, name, onChange, value, className } = props;

  const handleToggleDown = () => {
    const newValue = value > min ? value - 1 : value;

    if (!disabled) onChange(newValue);
  };

  const handleToggleUp = () => {
    const newValue = value < max ? value + 1 : value;

    if (!disabled) onChange(newValue);
  };

  const handleKeyDown = (key) => {
    const { keyCode } = key;

    if (keyCode === 38) {
      handleToggleUp();
    }
    if (keyCode === 40) {
      handleToggleDown();
    }
  };

  const handleFocus = () => {
    document.addEventListener('keydown', handleKeyDown);
  };

  const handleBlur = () => {
    document.removeEventListener('keydown', handleKeyDown);
  };

  return (
    <NumberToggleWrapper className={className}>
      <NumberToggleUp
        aria-label="Increase"
        className={disabled ? 'disabled' : ''}
        data-cy="nt-increase"
        type="button"
        onClick={handleToggleUp}
      />
      <NumberToggleInput
        data-cy="nt-input"
        type="number"
        name={name}
        defaultValue={value}
        onFocus={handleFocus}
        onBlur={handleBlur}
      />
      <NumberToggleInputClone className={disabled ? 'disabled' : ''} data-cy="nt-clone">
        {value}
      </NumberToggleInputClone>
      <NumberToggleDown
        aria-label="Decrease"
        className={disabled ? 'disabled' : ''}
        data-cy="nt-decrease"
        type="button"
        onClick={handleToggleDown}
      />
    </NumberToggleWrapper>
  );
}

NumberToggle.propTypes = {
  /**
   * disables the use of this component, and updates the styles
   */
  disabled: PropTypes.bool,
  /**
   * sets the maximum value
   */
  max: PropTypes.number,
  /**
   * sets the minimum value
   */
  min: PropTypes.number,
  /**
   * name attribute applied to input
   */
  name: PropTypes.string,
  /**
   *  callback function when the number value changes. Returns number value.
   */
  onChange: PropTypes.func.isRequired,
  /**
   *  number value
   */
  value: PropTypes.number,
  /**
   * Classname for styling purposes
   */
  className: PropTypes.string
};

NumberToggle.defaultProps = {
  disabled: false,
  max: 5000,
  min: 0,
  name: undefined,
  value: 0,
  className: ''
};

export default NumberToggle;
